import {RecordTableParams} from "../types/records-table.types";

export const defaultRecordTableParams: RecordTableParams = {
  actions: [],
  fields: [],
  properties: null
};

